export const navbarData = [
  {
    id: 1,
    title: "home",
    link: "/",
  },

  {
    id: 2,
    title: "courses",
    link: "/courses",
  },

  {
    id: 3,
    title: "enroll",
    link: "/enroll",
  },

  {
    id: 4,
    title: "videoCourses",
    link: "/videoCourses",
  },

  {
    id: 5,
    title: "about",
    link: "/about",
  },

  {
    id: 6,
    title: "contactUs",
    link: "/contactUs",
  },
];
